import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ClientService = /** @class */ (function () {
    function ClientService(httpClient) {
        this.httpClient = httpClient;
    }
    ClientService.prototype.getClient = function (clientId) {
        var _this = this;
        if (this.clients != null) {
            return this.findClient(clientId);
        }
        else {
            return this.fetchClients().pipe(map(function (p) {
                return _this.findClient(clientId);
            }));
        }
    };
    ClientService.prototype.setClient = function (clientId) {
        this.clientId = clientId.toLowerCase();
    };
    ClientService.prototype.findClient = function (clientId) {
        if (this.clients != null) {
            return this.clients[clientId || this.clientId];
        }
        return null;
    };
    ClientService.prototype.fetchClients = function () {
        var _this = this;
        return this.httpClient.get('./assets/clients.json')
            .pipe(tap(function (response) {
            _this.clients = response;
        }));
    };
    ClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClientService_Factory() { return new ClientService(i0.ɵɵinject(i1.HttpClient)); }, token: ClientService, providedIn: "root" });
    return ClientService;
}());
export { ClientService };
